import React from 'react'

import { Button, Col, InputNumber, Row, Switch } from 'antd'

import {
    _postToggleModule
} from '../../services'

class EnterpriseAddOns extends React.Component {
    // undefined until edited, so the field follows the enterprise once it loads
    state = {
        checkoutThreshold: undefined
    }

    render() {

        const moduleToggles = [{
            key: 'contract',
            title: 'Contract'
        }, {
            title: 'Send Invoice On Checkout',
            key: 'sendInvoiceOnCheckOut'
        }, 
        // {
        //     title: 'Block Agent Email On Claim',
        //     key: 'blockAgentEmailOnClaim'
        // }, 
        {
            title: 'Hide Credit Remaining',
            key: 'hideCreditRemaining'
        }, {
            title: "Flexible Addresses",
            key: 'flexibleAddress'
        }, {
            title: "Block Non Super User From Checkout",
            key: 'blockNonSuperUserFromCheckout'
        }, {
            title: "Block checkout above threshold (excl. GST)",
            key: 'blockCheckoutAboveThreshold'
        }];

        const sellerCenterModules = [
            {
                title: "Seller Center",
                key: 'sellerCenter'
            },
            {
                title: "Seller Center Company Page",
                key: 'sellerCenterCompanyPage'
            },
            {
                title: "Seller Center Punchout (Requires Company Page)",
                key: 'sellerCenterPunchout'
            }
        ]

        return (
            <div style={{ padding: '24px 0px' }}>
                <Row gutter={16}>
                    <Col span={8}>
                        <h3>Buyer Enterprise Add Ons / Modules: </h3>
                        {moduleToggles.map(this.renderControl)}
                        {this.renderCheckoutThreshold()}
                    </Col>
                    <Col span={8}>
                        <h3>Seller Enterprise Add Ons / Modules: </h3>
                        {sellerCenterModules.map(this.renderControl)}
                    </Col>

                </Row>
            </div>
        )
    }

    renderControl = (_module) => {

        const { enterprise } = this.props;

        return (
            <div style={{ marginBottom: 12 }}>
                <span style={{ marginRight: 12 }}>{_module.title}</span>
                <Switch
                    onChange={() => this.handleToggleModule(_module.key)}
                    checked={enterprise.modules && enterprise.modules[_module.key]}
                />
            </div>
        )

    }

    renderCheckoutThreshold = () => {

        const { enterprise } = this.props;
        const checkoutThreshold = this.state.checkoutThreshold === undefined
            ? enterprise.checkoutThreshold
            : this.state.checkoutThreshold;

        if (!(enterprise.modules && enterprise.modules.blockCheckoutAboveThreshold)) {
            return null;
        }

        return (
            <div style={{ marginBottom: 12 }}>
                <span style={{ marginRight: 12 }}>Checkout threshold ($, excl. GST)</span>
                <InputNumber
                    min={0}
                    value={checkoutThreshold}
                    onChange={value => this.setState({ checkoutThreshold: value })}
                />
                <Button
                    style={{ marginLeft: 8 }}
                    disabled={!(checkoutThreshold > 0) || checkoutThreshold === enterprise.checkoutThreshold}
                    onClick={() => this.props.saveCheckoutThreshold({ checkoutThreshold })}
                >
                    Save
                </Button>
            </div>
        )

    }

    handleToggleModule = (moduleKey) => {
        _postToggleModule({ enterpriseId: this.props.enterprise._id, moduleKey })
            .then(res => {
                this.props.setEnterprise(res.data.enterprise)
            })
    }
}

export default EnterpriseAddOns


// WEBPACK FOOTER //
// ./src/components/enterprise/add-ons.js